(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samba-community"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sc').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const copy=JSON.parse(root.querySelector('[data-sc-copy]').textContent), c=copy.copy;
  const decoder=document.createElement('textarea');Object.keys(c).forEach(key=>{decoder.innerHTML=c[key];c[key]=decoder.value;});
  const q=s=>root.querySelector(s),money=n=>new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(n/100)+' AUD';
  let partner='sporties',products=[],rows=[],selected=null,loading=false;
  const eligible=p=>!/kids|junior|youth|child|windbreaker|jacket/i.test([p.title,p.product_type,...(p.tags||[])].join(' '))&&p.variants.some(v=>/^(Fan|Player)( \+ Personalisation)?$/i.test(v.title));
  const variantPrice=v=>Math.round(Number(v.price)*100);
  function summary(){let total=0,personal=0;rows.forEach(r=>{const v=r.product.variants.find(v=>String(v.id)===r.variant);if(!v)return;total+=variantPrice(v);if(/Personalisation/i.test(v.title)){const base=r.product.variants.find(b=>b.title===v.title.replace(' + Personalisation',''));if(base)personal+=variantPrice(v)-variantPrice(base);}});let saving=partner==='sporties'?Math.round(total*(rows.length>=8?.2:rows.length>=5?.15:0)):rows.length>=5?personal:0;q('[data-count]').textContent=rows.length;q('[data-subtotal]').textContent=money(total);q('[data-saving]').textContent='− '+money(saving);q('[data-total]').textContent=money(total-saving);q('[data-summary-partner]').textContent=partner==='sporties'?'Sporties FC':'Perth Futsal Collective';q('[data-progress]').textContent=partner==='sporties'?(rows.length>=8?c.sporties_unlocked:rows.length>=5?c.sporties_next.replace('{count}',8-rows.length):c.sporties_start.replace('{count}',5-rows.length)):(rows.length>=5?c.pfc_unlocked:c.pfc_start.replace('{count}',5-rows.length));}
  function setPartner(value){partner=value;root.querySelectorAll('[data-partner]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.partner===value));q('[data-benefit-title]').textContent=value==='sporties'?c.sporties_benefit:c.pfc_benefit;q('[data-benefit-copy]').textContent=value==='sporties'?c.sporties_rules:c.pfc_rules;q('[data-individual]').textContent=value==='sporties'?c.sporties_individual:c.pfc_individual;q('[data-partner-input]').value=value==='sporties'?'Sporties FC':'Perth Futsal Collective';summary();}
  root.querySelectorAll('[data-partner]').forEach(b=>b.addEventListener('click',()=>setPartner(b.dataset.partner)));
  root.querySelectorAll('[data-path]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-path]').forEach(x=>x.setAttribute('aria-pressed',x===b));root.querySelectorAll('[data-panel]').forEach(x=>x.hidden=x.dataset.panel!==b.dataset.path);}));
  function filter(){const term=q('[data-search]').value.toLowerCase();q('[data-product]').replaceChildren(new Option(c.choose_model,''));products.filter(p=>p.title.toLowerCase().includes(term)).forEach(p=>q('[data-product]').add(new Option(p.title,p.id)));}
  q('[data-search]').addEventListener('input',filter);
  q('[data-product]').addEventListener('change',()=>{selected=products.find(p=>String(p.id)===q('[data-product]').value);q('[data-selected]').hidden=!selected;if(!selected)return;q('[data-product-title]').textContent=selected.title;const img=q('[data-product-image]');img.src=selected.images[0]?.src||'';img.alt=selected.title;q('[data-product-price]').textContent=money(Math.min(...selected.variants.map(variantPrice)));});
  function field(label,node){const l=document.createElement('label');l.textContent=label;l.append(node);return l;}
  function renderRows(){q('[data-roster]').replaceChildren();rows.forEach((r,index)=>{const row=document.createElement('div');row.className='sc-player';const top=document.createElement('div');top.className='sc-player-top';const title=document.createElement('strong');title.textContent=(index+1)+'. '+r.product.title;const remove=document.createElement('button');remove.type='button';remove.className='sc-text-button';remove.textContent=c.remove;remove.addEventListener('click',()=>{rows.splice(index,1);renderRows();summary();});top.append(title,remove);const fields=document.createElement('div');fields.className='sc-player-fields';const size=document.createElement('select');['', 'S','M','L','XL','2XL'].forEach(s=>size.add(new Option(s||c.choose_size,s)));size.value=r.size;size.addEventListener('change',()=>r.size=size.value);const variant=document.createElement('select');r.product.variants.filter(v=>/^(Fan|Player)( \+ Personalisation)?$/.test(v.title)).forEach(v=>variant.add(new Option(v.title+' · '+money(variantPrice(v)),v.id)));variant.value=r.variant;const name=document.createElement('input');name.maxLength=30;name.value=r.name;name.autocomplete='off';name.addEventListener('input',()=>r.name=name.value);const number=document.createElement('input');number.inputMode='numeric';number.maxLength=3;number.value=r.number;number.addEventListener('input',()=>{number.value=number.value.replace(/\D/g,'');r.number=number.value;});const toggle=()=>{const personal=/Personalisation/.test(variant.selectedOptions[0]?.textContent||'');name.disabled=!personal;number.disabled=!personal;};variant.addEventListener('change',()=>{r.variant=variant.value;toggle();summary();});toggle();fields.append(field(c.size,size),field(c.version,variant),field(c.print_name,name),field(c.number,number));row.append(top,fields);q('[data-roster]').append(row);});}
  q('[data-add]').addEventListener('click',()=>{q('[data-error]').hidden=true;if(!selected){q('[data-error]').textContent=c.select_first;q('[data-error]').hidden=false;q('[data-product]').focus();return;}rows.push({product:selected,variant:String(selected.variants.find(v=>v.title==='Fan')?.id||selected.variants[0].id),size:'',name:'',number:''});renderRows();summary();});
  q('[data-export]').addEventListener('click',()=>{if(!rows.length){q('[data-error]').textContent=c.empty;q('[data-error]').hidden=false;return;}const csvCell=v=>'"'+String(v).replace(/^[=+@-]/,"'").replaceAll('"','""')+'"';const data=[['Partner','Jersey','Configuration','Size','Name','Number'],...rows.map(r=>{const v=r.product.variants.find(v=>String(v.id)===r.variant);return[partner,r.product.title,v.title,r.size,/Personalisation/.test(v.title)?r.name:'',/Personalisation/.test(v.title)?r.number:''];})].map(row=>row.map(csvCell).join(',')).join('\r\n');const url=URL.createObjectURL(new Blob([data],{type:'text/csv;charset=utf-8;'}));const a=document.createElement('a');a.href=url;a.download='samba-team-list.csv';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);});
  async function load(){if(loading)return;loading=true;q('[data-catalogue-status]').textContent=c.loading;try{const base=window.Shopify?.routes?.root||'/';let page=1;while(page<=20){const response=await fetch(base+'products.json?limit=250&page='+page);if(!response.ok)throw Error();const data=await response.json();products.push(...data.products.filter(eligible));if(data.products.length<250)break;page++;}filter();q('[data-catalogue-status]').textContent=c.catalogue_note;}catch{q('[data-catalogue-status]').textContent=c.load_error;}finally{loading=false;}}
  setPartner(new URLSearchParams(location.search).get('partner')==='pfc'?'pfc':'sporties');load();
});
document.querySelectorAll('.sc').forEach(root=>{
  if(root.dataset.identityReady)return;
  root.dataset.identityReady='true';
  const update=()=>{root.dataset.communityPartner=root.querySelector('[data-partner][aria-pressed="true"]')?.dataset.partner||'sporties';};
  root.querySelectorAll('[data-partner]').forEach(button=>{
    button.addEventListener('click',()=>{root.dataset.communityPartner=button.dataset.partner;});
    new MutationObserver(update).observe(button,{attributes:true,attributeFilter:['aria-pressed']});
  });
  update();
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('sc-reveal');observer.unobserve(entry.target);}}),{threshold:.12});
    root.querySelectorAll('.sc-partner,.sc-community-statement,.sc-section-head,.sc-closing').forEach(el=>observer.observe(el));
  }
});


  } catch(e) { console.error(e); }
})();
})();
